import request from './request'
// 获取消息列表
export const getMessageList = (params: any) =>
  request({
    url: '/carbon-misc/private/user/system/notice/page',
    method: 'get',
    params,
  })

export const updateMessageState = (data: any) =>
  request({
    url: '/carbon-misc/private/user/system/notice/read',
    method: 'post',
    data,
  })

export const getUnreadMessageCount = () =>
  request({
    url: '/carbon-misc/private/user/system/notice/count',
    method: 'get',
  })

export const deleteMessage = (data: any) =>
  request({
    url: '/carbon-misc/private/user/system/notice/delete',
    method: 'post',
    data,
  })
